var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { useState } from "react";
import { FormGroup } from 'reactstrap';
import Icon from "./Icon";
import { Input as InputReactstrap } from "reactstrap";

var CustomEmail = function (_InputReactstrap) {
    _inherits(CustomEmail, _InputReactstrap);

    function CustomEmail() {
        _classCallCheck(this, CustomEmail);

        return _possibleConstructorReturn(this, (CustomEmail.__proto__ || Object.getPrototypeOf(CustomEmail)).apply(this, arguments));
    }

    _createClass(CustomEmail, [{
        key: "render",
        value: function render() {

            return React.createElement(
                FormGroup,
                null,
                React.createElement(InputReactstrap, {
                    value: this.props.value,
                    name: this.props.name,
                    label: this.props.label,
                    onChange: this.props.onChange,
                    invalid: this.props.invalid,
                    valid: this.props.valid,
                    innerRef: this.props.innerRef,
                    htmlFor: this.props.htmlFor,
                    inline: this.props.inline,
                    id: this.props.id,
                    key: this.props.key,
                    size: this.props.size,
                    bsSize: this.props.bsSize,
                    required: true,
                    type: "email",
                    className: "custom-email" })
            );
        }
    }]);

    return CustomEmail;
}(InputReactstrap);

export default CustomEmail;